import { RootState } from 'types/RootState';
import { createSelector } from '@reduxjs/toolkit';
import { initialInterviewsState } from 'store/redux-store/candidate-interviews/initialState';

const domain = (state: RootState) => state.candidateInterview || initialInterviewsState;
export const interviewsSelector = createSelector(domain, state => state);
